import React, { useEffect, useState } from "react";
// import AboutArea from "../components/About/AboutArea";
// import CompanyAbout from "../components/About/CompanyAbout";
// import HistoryArea from "../components/About/HistoryArea";
// import Team from "../components/About/Team";
//import AboutArea from "../components/HomeTwo/AboutArea";

import Breadcrumb from "../components/common/Breadcrumb";
import Footer from "../components/common/Footer";
import Header from "../components/common/Header";
import SEO from "../components/seo";
import EagleVision from "./eagle-vision";
import { useLanguage } from "../contexts/LanguageContext";

const About = ({
  ABOUT_PAGE_TITLE = "About",
  BREADCRUMB_TITLE = "About us",
  BREADCRUMB_SUBTITLE = "About Company",
  HOME = "Home",
}) => {
  const { currentLanguage, translateContent } = useLanguage();
  const [translations, setTranslations] = useState({
    ABOUT_PAGE_TITLE, BREADCRUMB_TITLE, BREADCRUMB_SUBTITLE, HOME,
  });

  useEffect(() => {
    const translateAll = async () => {
      const keys = ['ABOUT_PAGE_TITLE', 'BREADCRUMB_TITLE', 'BREADCRUMB_SUBTITLE', 'HOME'];
      const originalTexts = { ABOUT_PAGE_TITLE, BREADCRUMB_TITLE, BREADCRUMB_SUBTITLE, HOME };
      const newTranslations = {};
      const translationPromises = keys.map(async (key) => {
        const translated = await translateContent(originalTexts[key]);
        return { key, translated };
      });
      const results = await Promise.all(translationPromises);
      results.forEach(({ key, translated }) => {
        newTranslations[key] = translated;
      });
      setTranslations(newTranslations);
    };
    translateAll();
  }, [currentLanguage, ABOUT_PAGE_TITLE, BREADCRUMB_TITLE, BREADCRUMB_SUBTITLE, HOME, translateContent]);

  return (
    <main>
      <SEO pageTitle={translations.ABOUT_PAGE_TITLE} />
      <Header />
      <Breadcrumb
        title={translations.BREADCRUMB_TITLE}
        subtitle={translations.BREADCRUMB_SUBTITLE}
        homeLabel={translations.HOME}
      />
      {/* <AboutArea/> */}
      <EagleVision />
      {/* <HistoryArea/>
      <Team/>
      <CompanyAbout/> */}
      <Footer />
    </main>
  );
};

export default About;